import { render, staticRenderFns } from "./confirm_modal.vue?vue&type=template&id=631ed740&scoped=true&"
import script from "./confirm_modal.vue?vue&type=script&lang=js&"
export * from "./confirm_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ed740",
  null
  
)

export default component.exports